import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faEllipsisH,faEye,faArchive,faEdit,faCross, faEllipsisV, faCashRegister, faChartLine, faCloudUploadAlt, faPlus, faRocket, faTasks, faUserShield, faUserAlt, faGamepad, faCrosshairs, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Button, Dropdown, ButtonGroup } from '@themesberg/react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { CounterWidget, CircleChartWidget, BarChartWidget, PieChartWidget, DognutChartWidget, TeamMembersWidget, ProgressTrackWidget, EventsWidget, RankingWidget, VisitsMapWidget, SalesValueWidget,SalesValueWidgetphone, AcquisitionWidget } from "../../components/Widgets";
import { PageVisitsTable } from "../../components/Tables";
import { trafficShares, totalOrders, trafficBySource, trafficDistribution } from "../../data/charts";
import imgnew from '../Images/download.png'
import '../css/games.css'
import axios from '../../utlis/interceptor';
import { BASE_URL, SEARCH_LEADERBOARD, GET_COMPETITION, TOTAL_MONEY_COLLECTED, TOTAL_HOSTING_FEE_COLLECTED, SIGN_UP } from "../../resources/APIEndpoints";
import { getLeaderboardByIdAction, getUniversalLeaderboardAction } from "../../redux/action/leaderboardAction";
import { getallCompetitionAction } from "../../redux/action/competitionAction";
import { Link } from "react-router-dom";
import { Routes } from "../../routes";
import {Line, Chart, Doughnut } from 'react-chartjs-2';
// import {} from 'react-chartjs-2'
import {Chart as ChartJS} from 'chart.js/auto'
import { Breadcrumb } from "react-bootstrap";
import {getTotalMoneyCollectedAction, getTotalChallengesAction, getTotalLiveCompetitionAction} from '../../redux/action/analyticsAction'
import { analyticsReducer } from "../../redux/reducer/analyticsReducer";
import moment from "moment";
import Badge from '@mui/material/Badge';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { borderRadius } from "@mui/system";

export default () => {
  
  const dispatch = useDispatch()

  /* Playstarz Leaderboard */
  const [playstarzLeaderboardDetail, setPlaystarzLeaderboardDetail] = useState()
  const [dateStart, setDate] = useState(new Date().toISOString().slice(0, 10))

  /* Show Daily, Weekly, Monthly and All Time Graph */
  const [daily, setDailly] = useState(false)
  const [yesterday, setyesterday] = useState(false)
  const [Weekly, setWeekly] = useState(false)
  const [weekLast, setWeekLast] = useState(false)
  const [monthly, setMonthly] = useState(false)
  const [monthLast, setMonthLast] = useState(false)
  const [alltime, setAllTime] = useState(true)

  const [envType, setEnvType] = useState()

  /* Graph Data and Labels */
  const [label, setLabels] = useState([])
  const [totalMoneyData, setTotalMoneyData] = useState([])
  const [hostData, setHostData] = useState([])
  const [hostLabel, setHostLabel] = useState([])
  const [signUpLabel, setSignUpLabel] = useState([])
  const [signUpData, setSignUpData] = useState([])

  useEffect(()=>{
    playstarzLeaderboard();
    statistics();
    upcomingCompetition()

    setEnvType(localStorage.getItem('type'))

  }, [dailyMoney, weeklyMoney, monthlyMoney, allTimeMoney])

  useEffect(()=>{
    initialTotalMoney();
    initialHostingFee();
    initialSignUp();

    getTotalLiveCompetition();
  }, [option, intervalId, durationOne, durationTwo, durationThree])


  /* Get Playstarz Leaderboard Data */

  const getTotalLiveCompetition = () => {
    let statData = {}
    dispatch(getTotalLiveCompetitionAction(statData));
    dispatch(getTotalChallengesAction(statData))
  }

  let totalLiveCompetition = useSelector((state)=>{
      return state.analytics.liveCompetition
  })

  let totalChallenges = useSelector((state)=>{
    return state.analytics.totalChallenges
  })

  let totalPaidChallenges = useSelector((state)=>{
    return state.analytics.totalPaidChallenges
  })

  const playstarzLeaderboard = async() => {
    let searchLeaderboard = {
      leaderboardName : "playstarz"
    }
    await axios.post(BASE_URL + SEARCH_LEADERBOARD, searchLeaderboard)
    .then(res=>{
      if(res.data.leaderboardData.length > 0){
      setPlaystarzLeaderboardDetail(res.data.leaderboardData[0].id)
      }
    })
    
    
    let leaderboardPlaystarz = envType == 'Development' ? "0280c259-f9ec-4f63-99cc-2e78a9c78f5c"  : '0280c259-f9ec-4f63-99cc-2e78a9c78f5c'
    const leaderboard_Playstarz = {
      leaderboardId : leaderboardPlaystarz,
      getUniversalLeaderboardDetailsFilters : {
          intervalId : 5,
          startsFrom : "2020-12-31"
      },
      pagination : {
          offset : 0,
          limit : 10
      }
  }
  dispatch(getUniversalLeaderboardAction(leaderboard_Playstarz))
  }

  /* Games and Competition Statistics */
  const [gameStats, setGameStats] = useState()
  const [competitionStats, setCompetitionStats] = useState()

  const statistics = () => {
    const game_Stats = {
      gameFilters:{},
      entities:[{value: "Match", attributes : ["id", "matchName"]}]
    }
    axios.post(`${BASE_URL}/game/getGame`, game_Stats)
    .then(res=>{
      setGameStats(res.data.gameData.length)
    })

    const competition_Stats = {
      competitionFilters : {
          pagination : {
  
          }
      }
  }
  axios.post(BASE_URL + GET_COMPETITION, competition_Stats) 
  .then(res=>{
      setCompetitionStats(res.data.competitionData.length)
  })  
    
  }

  /* Get Upcoming Competition Data */
  const upcomingCompetition = () => {

    let allCompetition = {
      competitionFilters: {
          pagination : {}
      }
    }

    dispatch(getallCompetitionAction(allCompetition))

    // setInterval(() => {
    //   dispatch(getallCompetitionAction(allCompetition))
    // }, 60000);
  }

  let Leaderboard = useSelector((state)=>{ 
    return state.leaderboard.UniversalLeaderboardDetail
  })

  let competition = useSelector((state)=>{ 
    return state.competition.competitions
  })

 
  /* Static Graph Data and Configuration */


  const hostingFeeData = {
  labels: hostLabel,
  datasets: [{
      label: 'Total Hosting Fee Collected',
      data: hostData,
      borderColor: 'rgba(122, 75, 255, 1)',
      backgroundColor : 'rgba(122, 75, 255, 0.3)',
      borderWidth : 3,
      borderCapStyle : 'butt',
      fill: true,
      tension: 0.4,
      pointStyle: 'circle',
      pointRadius: 1,
      pointHoverRadius: 5,
      pointBorderColor : 'rgba(122, 75, 255, 1)',
      pointBackgroundColor : '#fff' ,
      pointHoverBorderColor : 'rgba(122, 75, 255, 1)',
      pointHoverBackgroundColor : '#fff',
      pointHoverBorderWidth : 2
  }]
  };

  const moneyCollectedData = {
  labels: label,
  datasets: [{
      label: 'Prize Money Distributed',
      data: totalMoneyData ,
      fill: false,
      borderColor: 'rgba(255, 45, 25, 1)',
      backgroundColor : 'rgba(255, 45, 25, 0.3)',
      borderWidth : 3,
      borderCapStyle : 'butt',
      fill: true,
      tension: 0.4,
      pointStyle: 'circle',
      pointRadius: 1,
      pointHoverRadius: 5,
      pointBorderColor : 'rgba(255, 45, 25, 1)',
      pointBackgroundColor : '#fff' ,
      pointHoverBorderColor : 'rgba(255, 45, 25, 1)',
      pointHoverBackgroundColor : '#fff',
      pointHoverBorderWidth : 2
  }]
  };

  const userData = {
    labels: signUpLabel,
    datasets: [{
        label: 'Total SignUp',
        data: signUpData,
        borderColor: 'rgba(255, 171, 0, 1)',
        backgroundColor : 'rgba(255, 171, 0, 0.3)',
        borderWidth : 3,
        borderCapStyle : 'butt',
        fill: true,
        tension: 0.4,
        pointStyle: 'circle',
        pointRadius: 1,
        pointHoverRadius: 5,
        pointBorderColor : 'rgba(255, 171, 0, 1)',
        pointBackgroundColor : '#fff' ,
        pointHoverBorderColor : 'rgba(255, 171, 0, 1)',
        pointHoverBackgroundColor : '#fff',
        pointHoverBorderWidth : 2
    }]
    };


  let options = {
    plugins: {
      legend: {
        display: false,
      }
    },
    maintainAspectRatio: false,
    scales: {
      x: {
        display: false,
      },
      y: {
        display: false,
        beginAtZero: true
      }
    }
  }

  let optionsNew = {
    plugins: {
      legend: {
        display : false,
      }
    },
    maintainAspectRatio: false,
    scales: {
      x: {
        display: true,
      },
      y: {
        suggestedMin: 50,
        suggestedMax: 100,
        display: true,
      }
    }
  }

  const [option, setOption] = useState(options)

  const [dailyMoney, setDailyMoney] = useState(0)
  const [moneyDateFrom, setMoneyDateFrom] = useState()
  const [moneyDateTo, setMoneyDateTo] = useState()
  const [totalHostingFee, setTotalHostingFee] = useState(0)
  const [hostingDateFrom, setHostingDateFrom] = useState()
  const [hostingDateTo, setHostingDateTo] = useState()
  const [totalSignUp, setTotalSignUp] = useState(0)
  const [signUpDateFrom, setSignUpDateFrom] = useState()
  const [signUpDateTo, setSignUpDateTo] = useState()


  const[moneyDaily, setMoneyDaily] = useState(false)
  const[moneyYestrday, setMoneyYestrday] = useState(false)
  const[moneyweekly, setMoneyWeekly] = useState(false)
  const[moneyLastWeek, setMoneyLastWeek] = useState(false)
  const[moneyMonthly, setMoneyMonthly] = useState(false)
  const[moneyLastMonth, setMoneyLastMonth] = useState(false)
  const[moneyAllTime, setMoneyAllTime] = useState(true)


  const[signUpDaily, setSignUpDaily] = useState(false)
  const[signUpYesterday, setSignUpYesterday] = useState(false)
  const[signUpMonthly, setSignUpMonthly] = useState(false)
  const[signUpLastMonth, setSignUpLastMonth] = useState(false)
  const[signUpWeekly, setSignUpWeekly] = useState(false)
  const[signUpLastWeek, setSignUpLastWeek] = useState(false)
  const[signUpAllTime, setSignUpAllTime] = useState(true)
  

  const changeDaily = async(type) => {

    if(type == 'totalMoney'){
      setDurationOne(1)
      let moneyCollectedData = {
        intervalId : 1,
        startsFrom : startFrom
      }
  
      let Label_X = []
      let Label_Y = []
      let totalMoney = 0;
      
      let res = await axios.post(BASE_URL + TOTAL_MONEY_COLLECTED , moneyCollectedData)
  
      res.data.data.forEach((element)=>{
        
        Label_X.push(moment(new Date(element.x)).format("HH:mm"))
        setLabels(Label_X)
  
        Label_Y.push(element.y)
        setTotalMoneyData(Label_Y)

        setMoneyDateFrom(moment(startFrom).format('MMMM DD, YYYY'))
        setMoneyDateTo(moment(startFrom).format('MMMM DD, YYYY'))

        totalMoney = totalMoney + parseInt(element.y)
        setDailyMoney(totalMoney)

      }) 

      setMoneyDaily(true)
      setMoneyYestrday(false)
      setMoneyWeekly(false)
      setMoneyLastWeek(false)
      setMoneyMonthly(false)
      setMoneyLastMonth(false)
      setMoneyAllTime(false)

    }else if(type == 'hostingFee'){
      setDurationTwo(1)
      let hostingFeeData = {
        intervalId : 1,
        startsFrom : startFrom
      }
  
      let Label_X = []
      let Label_Y = []
      let hostingTotal = 0
      
      let res = await axios.post(BASE_URL + TOTAL_HOSTING_FEE_COLLECTED , hostingFeeData)
      res.data.data.forEach((element)=>{
        
        Label_X.push(moment(new Date(element.x)).format("HH:mm"))
        setHostLabel(Label_X)
  
        Label_Y.push(element.y)
        setHostData(Label_Y)

        setHostingDateFrom(moment(startFrom).format('MMMM DD, YYYY'))
        setHostingDateTo(moment(startFrom).format('MMMM DD, YYYY'))

        hostingTotal = hostingTotal + parseInt(element.y)
        setTotalHostingFee(hostingTotal)

      })

      setDailly(true)
      setyesterday(false)
      setWeekly(false)
      setWeekLast(false)
      setMonthly(false)
      setMonthLast(false)
      setAllTime(false)

    }else if(type == 'signUp'){
      setDurationThree(1)
      let signUpData = {
        intervalId : 1,
        startsFrom : startFrom
      }
  
      let Label_X = []
      let Label_Y = []
      let signUpTotal = 0
      
      let res = await axios.post(BASE_URL + SIGN_UP , signUpData)

      res.data.data.forEach((element)=>{
        
        Label_X.push(moment(new Date(element.x)).format("HH:mm"))
        setSignUpLabel(Label_X)
  
        Label_Y.push(element.y)
        setSignUpData(Label_Y)

        setSignUpDateFrom(moment(startFrom).format('MMMM DD, YYYY'))
        setSignUpDateTo(moment(startFrom).format('MMMM DD, YYYY'))

        signUpTotal = signUpTotal + parseInt(element.y)
        setTotalSignUp(signUpTotal)

      })

      setSignUpDaily(true)
      setSignUpYesterday(false)
      setSignUpWeekly(false)
      setSignUpLastWeek(false)
      setSignUpMonthly(false)
      setSignUpLastMonth(false)
      setSignUpAllTime(false)

    }


  }  

  const[Yesterday, setYesterday] = useState(false)
  const changeYesterday = async(type) => {

    if(type == 'totalMoney'){
      setDurationOne(2)
      let moneyCollectedData = {
        intervalId : 1,
        startsFrom : moment().subtract(1, 'day').format("YYYY-MM-DD")
      }
  
      let Label_X = []
      let Label_Y = []
      let totalMoney = 0;
      
      let res = await axios.post(BASE_URL + TOTAL_MONEY_COLLECTED , moneyCollectedData)
      res.data.data.forEach((element)=>{
        
        Label_X.push(moment(new Date(element.x)).format("HH:mm"))
        setLabels(Label_X)
  
        Label_Y.push(element.y)
        setTotalMoneyData(Label_Y)

        totalMoney = totalMoney + parseInt(element.y)
        setDailyMoney(totalMoney)

        setMoneyDateFrom(moment().subtract(1, 'day').format('MMMM DD, YYYY'))
        setMoneyDateTo(moment().subtract(1, 'day').format('MMMM DD, YYYY'))
        
      }) 

      setMoneyDaily(false)
      setMoneyYestrday(true)
      setMoneyWeekly(false)
      setMoneyLastWeek(false)
      setMoneyMonthly(false)
      setMoneyLastMonth(false)
      setMoneyAllTime(false)

    }else if(type == 'hostingFee'){
      setDurationTwo(2)
      let hostingFeeData = {
        intervalId : 1,
        startsFrom : moment().subtract(1, 'day').format("YYYY-MM-DD")
      }
  
      let Label_X = []
      let Label_Y = []
      let hostingTotal = 0
      
      let res = await axios.post(BASE_URL + TOTAL_HOSTING_FEE_COLLECTED , hostingFeeData)

      res.data.data.forEach((element)=>{
        
        Label_X.push(moment(new Date(element.x)).format("HH:mm"))
        setHostLabel(Label_X)
  
        Label_Y.push(element.y)
        setHostData(Label_Y)

        hostingTotal = hostingTotal + parseInt(element.y)
        setTotalHostingFee(hostingTotal)

        setHostingDateFrom(moment().subtract(1, 'day').format('MMMM DD, YYYY'))
        setHostingDateTo(moment().subtract(1, 'day').format('MMMM DD, YYYY'))

      })

      setDailly(false)
      setyesterday(true)
      setWeekly(false)
      setWeekLast(false)
      setMonthly(false)
      setMonthLast(false)
      setAllTime(false)
      
    }else if(type == 'signUp'){
      setDurationThree(2)
      let signUpData = {
        intervalId : 1,
        startsFrom : moment().subtract(1, 'day').format("YYYY-MM-DD")
      }
  
      let Label_X = []
      let Label_Y = []
      let signUpTotal = 0;
      
      let res = await axios.post(BASE_URL + SIGN_UP , signUpData)

      res.data.data.forEach((element)=>{
        
        Label_X.push(moment(new Date(element.x)).format("HH:mm"))
        setSignUpLabel(Label_X)
  
        Label_Y.push(element.y)
        setSignUpData(Label_Y)

        signUpTotal = signUpTotal + parseInt(element.y)
        setTotalSignUp(signUpTotal)

        setSignUpDateFrom(moment().subtract(1, 'day').format('MMMM DD, YYYY'))
        setSignUpDateTo(moment().subtract(1, 'day').format('MMMM DD, YYYY'))

      })

      setSignUpDaily(false)
      setSignUpYesterday(true)
      setSignUpWeekly(false)
      setSignUpLastWeek(false)
      setSignUpMonthly(false)
      setSignUpLastMonth(false)
      setSignUpAllTime(false)

    }

  }

  const [weeklyMoney, setWeeklyMoney] = useState(0)

  const changeWeekly = async(type) => {

    if(type == 'totalMoney'){
    setDurationOne(3)
    let moneyCollectedData = {
      intervalId : 2,
      startsFrom : moment().startOf('week').format("YYYY-MM-DD")
    }

    let Label_X = []
    let Label_Y = []
    let totalMoney = 0;
    
    let res = await axios.post(BASE_URL + TOTAL_MONEY_COLLECTED , moneyCollectedData)

    res.data.data.forEach((element)=>{
      Label_X.push(element.x.slice(0,10))
      setLabels(Label_X)

      Label_Y.push(element.y)
      setTotalMoneyData(Label_Y)

      totalMoney = totalMoney + parseInt(element.y)
      setDailyMoney(totalMoney)

      setMoneyDateFrom(moment().startOf('week').format('MMMM DD, YYYY'))
      setMoneyDateTo(moment().endOf('week').format('MMMM DD, YYYY'))

    })

    setMoneyDaily(false)
    setMoneyYestrday(false)
    setMoneyWeekly(true)
    setMoneyLastWeek(false)
    setMoneyMonthly(false)
    setMoneyLastMonth(false)
    setMoneyAllTime(false)

  }else if(type == 'hostingFee'){
    setDurationTwo(3)
    let hostingFeeData = {
      intervalId : 2,
      startsFrom : moment().startOf('week').format("YYYY-MM-DD")
    }

    let Label_X = []
    let Label_Y = []
    let hostingTotal = 0;
    
    let res = await axios.post(BASE_URL + TOTAL_HOSTING_FEE_COLLECTED , hostingFeeData)

    res.data.data.forEach((element)=>{
      Label_X.push(element.x.slice(0,10))
      setHostLabel(Label_X)

      Label_Y.push(element.y)
      setHostData(Label_Y)

      hostingTotal = hostingTotal + parseInt(element.y)
      setTotalHostingFee(hostingTotal)

      setHostingDateFrom(moment().startOf('week').format('MMMM DD, YYYY'))
      setHostingDateTo(moment().endOf('week').format('MMMM DD, YYYY'))

    })

    setDailly(false)
    setyesterday(false)
    setWeekly(true)
    setWeekLast(false)
    setMonthly(false)
    setMonthLast(false)
    setAllTime(false)

  }else if(type == 'signUp'){
    setDurationThree(3)
    let signUpData = {
      intervalId : 2,
      startsFrom : moment().startOf('week').format("YYYY-MM-DD")
    }

    let Label_X = []
    let Label_Y = []
    let signUpTotal = 0;
    
    let res = await axios.post(BASE_URL + SIGN_UP , signUpData)

    res.data.data.forEach((element)=>{
      
      Label_X.push(element.x.slice(0,10))
      setSignUpLabel(Label_X)

      Label_Y.push(element.y)
      setSignUpData(Label_Y)

      signUpTotal = signUpTotal + parseInt(element.y)
      setTotalSignUp(signUpTotal)

      setSignUpDateFrom(moment().startOf('week').format('MMMM DD, YYYY'))
      setSignUpDateTo(moment().endOf('week').format('MMMM DD, YYYY'))

    })

    setSignUpDaily(false)
    setSignUpYesterday(false)
    setSignUpWeekly(true)
    setSignUpLastWeek(false)
    setSignUpMonthly(false)
    setSignUpLastMonth(false)
    setSignUpAllTime(false)

  }
    
  }

  const [lastWeek, setLastWeek] = useState(false)
  const changeLastWeek = async(type) => {

    if(type == 'totalMoney'){
      setDurationOne(4)
    let moneyCollectedData = {
      intervalId : 2,
      startsFrom : moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD')
    }

    let Label_X = []
    let Label_Y = []
    let totalMoney = 0;
    
    let res = await axios.post(BASE_URL + TOTAL_MONEY_COLLECTED , moneyCollectedData)

    res.data.data.forEach((element)=>{
      Label_X.push(element.x.slice(0,10))
      setLabels(Label_X)

      Label_Y.push(element.y)
      setTotalMoneyData(Label_Y)
      
      totalMoney = totalMoney + parseInt(element.y)
      setDailyMoney(totalMoney)

      setMoneyDateFrom(moment().subtract(1, 'weeks').startOf('week').format('MMMM DD, YYYY'))
      setMoneyDateTo(moment().subtract(1, 'weeks').endOf('week').format('MMMM DD, YYYY'))

    })

    setMoneyDaily(false)
    setMoneyYestrday(false)
    setMoneyWeekly(false)
    setMoneyLastWeek(true)
    setMoneyMonthly(false)
    setMoneyLastMonth(false)
    setMoneyAllTime(false)

  }else if(type == 'hostingFee'){
    setDurationTwo(4)
    let hostingFeeData = {
      intervalId : 2,
      startsFrom : moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD')
    }

    let Label_X = []
    let Label_Y = []
    let hostingTotal = 0
    
    let res = await axios.post(BASE_URL + TOTAL_HOSTING_FEE_COLLECTED , hostingFeeData)

    res.data.data.forEach((element)=>{
      
      Label_X.push(element.x.slice(0,10))
      setHostLabel(Label_X)

      Label_Y.push(element.y)
      setHostData(Label_Y)

      hostingTotal = hostingTotal + parseInt(element.y)
      setTotalHostingFee(hostingTotal)

      setHostingDateFrom(moment().subtract(1, 'weeks').startOf('week').format('MMMM DD, YYYY'))
      setHostingDateTo(moment().subtract(1, 'weeks').endOf('week').format('MMMM DD, YYYY'))
    })

    setDailly(false)
    setyesterday(false)
    setWeekly(false)
    setWeekLast(true)
    setMonthly(false)
    setMonthLast(false)
    setAllTime(false)

  }else if(type == 'signUp'){
    setDurationThree(4)
    let signUpData = {
      intervalId : 2,
      startsFrom : moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD')
    }

    let Label_X = []
    let Label_Y = []
    let signUpTotal = 0;
    
    let res = await axios.post(BASE_URL + SIGN_UP , signUpData)

    res.data.data.forEach((element)=>{
      
      Label_X.push(element.x.slice(0,10))
      setSignUpLabel(Label_X)

      Label_Y.push(element.y)
      setSignUpData(Label_Y)

      signUpTotal = signUpTotal + parseInt(element.y)
      setTotalSignUp(signUpTotal)

      setSignUpDateFrom(moment().subtract(1, 'weeks').startOf('week').format('MMMM DD, YYYY'))
      setSignUpDateTo(moment().subtract(1, 'weeks').endOf('week').format('MMMM DD, YYYY'))

    })

    setSignUpDaily(false)
    setSignUpYesterday(false)
    setSignUpWeekly(false)
    setSignUpLastWeek(true)
    setSignUpMonthly(false)
    setSignUpLastMonth(false)
    setSignUpAllTime(false)

  }
    
  }

  const [monthlyMoney, setMonthlyMoney] = useState(0)

  const changeMonthly = async(type) => {

    if(type == 'totalMoney'){
    setDurationOne(5)
    let moneyCollectedData = {
      intervalId : 3,
      startsFrom : moment().startOf('month').format('YYYY-MM-DD')
    }

    let Label_X = []
    let Label_Y = []
    let totalMoney = 0;
    
    let res = await axios.post(BASE_URL + TOTAL_MONEY_COLLECTED , moneyCollectedData)

    res.data.data.forEach((element)=>{
      Label_X.push(moment(element.x.slice(0,10)).format('DD MMM'))
      setLabels(Label_X)

      Label_Y.push(element.y)
      setTotalMoneyData(Label_Y)
      
      totalMoney = totalMoney + parseInt(element.y)
      setDailyMoney(totalMoney)

      setMoneyDateFrom(moment().startOf('month').format('MMMM DD, YYYY'))
      setMoneyDateTo(moment().endOf('month').format('MMMM DD, YYYY'))

    })

    setMoneyDaily(false)
    setMoneyYestrday(false)
    setMoneyWeekly(false)
    setMoneyLastWeek(false)
    setMoneyMonthly(true)
    setMoneyLastMonth(false)
    setMoneyAllTime(false)

  }else if(type == 'hostingFee'){
    setDurationTwo(5)
    let hostingFeeData = {
      intervalId : 3,
      startsFrom : moment().startOf('month').format('YYYY-MM-DD')
    }

    let Label_X = []
    let Label_Y = []
    let hostingTotal = 0;
    
    let res = await axios.post(BASE_URL + TOTAL_HOSTING_FEE_COLLECTED , hostingFeeData)

    res.data.data.forEach((element)=>{
      
      Label_X.push(moment(element.x.slice(0,10)).format('DD MMM'))
      setHostLabel(Label_X)

      Label_Y.push(element.y)
      setHostData(Label_Y)

      hostingTotal = hostingTotal + parseInt(element.y)
      setTotalHostingFee(hostingTotal)

      setHostingDateFrom(moment().startOf('month').format('MMMM DD, YYYY'))
      setHostingDateTo(moment().endOf('month').format('MMMM DD, YYYY'))

    })

    setDailly(false)
    setyesterday(false)
    setWeekly(false)
    setWeekLast(false)
    setMonthly(true)
    setMonthLast(false)
    setAllTime(false)

  }else if(type == 'signUp'){
    setDurationThree(5)
    let signUpData = {
      intervalId : 3,
      startsFrom : moment().startOf('month').format('YYYY-MM-DD')
    }

    let Label_X = []
    let Label_Y = []
    let signUpTotal = 0;
    
    let res = await axios.post(BASE_URL + SIGN_UP , signUpData)

    res.data.data.forEach((element)=>{
      
      Label_X.push(moment(element.x.slice(0,10)).format('DD MMM'))
      setSignUpLabel(Label_X)

      Label_Y.push(element.y)
      setSignUpData(Label_Y)

      signUpTotal = signUpTotal + parseInt(element.y)
      setTotalSignUp(signUpTotal)

      setSignUpDateFrom(moment().startOf('month').format('MMMM DD, YYYY'))
      setSignUpDateTo(moment().endOf('month').format('MMMM DD, YYYY'))

    })

    setSignUpDaily(false)
    setSignUpYesterday(false)
    setSignUpWeekly(false)
    setSignUpLastWeek(false)
    setSignUpMonthly(true)
    setSignUpLastMonth(false)
    setSignUpAllTime(false)

  }

  }

  const [lastMonth, setLastMonth] = useState(false)
  const changeLastMonth = async(type) => {

    if(type == 'totalMoney'){
    setDurationOne(6)
    let moneyCollectedData = {
      intervalId : 3,
      startsFrom : moment().subtract(1, 'month').startOf('month').format("YYYY-MM-DD")
    }

    let Label_X = []
    let Label_Y = []
    let totalMoney = 0;
    
    let res = await axios.post(BASE_URL + TOTAL_MONEY_COLLECTED , moneyCollectedData)

    res.data.data.forEach((element)=>{
      Label_X.push(moment(element.x.slice(0,10)).format('DD MMM'))
      setLabels(Label_X)

      Label_Y.push(element.y)
      setTotalMoneyData(Label_Y)

      totalMoney = totalMoney + parseInt(element.y)
      setDailyMoney(totalMoney)

      setMoneyDateFrom(moment().subtract(1, 'month').startOf('month').format('MMMM DD, YYYY'))
      setMoneyDateTo(moment().subtract(1, 'month').endOf('month').format('MMMM DD, YYYY'))

    })

    setMoneyDaily(false)
    setMoneyYestrday(false)
    setMoneyWeekly(false)
    setMoneyLastWeek(false)
    setMoneyMonthly(false)
    setMoneyLastMonth(true)
    setMoneyAllTime(false)

  }else if(type == 'hostingFee'){
    setDurationTwo(6)
    let hostingFeeData = {
      intervalId : 3,
      startsFrom : moment().subtract(1, 'month').startOf('month').format("YYYY-MM-DD")
    }

    let Label_X = []
    let Label_Y = []
    let hostingTotal = 0;
    
    let res = await axios.post(BASE_URL + TOTAL_HOSTING_FEE_COLLECTED , hostingFeeData)

    res.data.data.forEach((element)=>{
      
      Label_X.push(moment(element.x.slice(0,10)).format('DD MMM'))
      setHostLabel(Label_X)

      Label_Y.push(element.y)
      setHostData(Label_Y)

      hostingTotal = hostingTotal + parseInt(element.y)
      setTotalHostingFee(hostingTotal)

      setHostingDateFrom(moment().subtract(1, 'month').startOf('month').format('MMMM DD, YYYY'))
      setHostingDateTo(moment().subtract(1, 'month').endOf('month').format('MMMM DD, YYYY'))
      
    })

    setDailly(false)
    setyesterday(false)
    setWeekly(false)
    setWeekLast(false)
    setMonthly(false)
    setMonthLast(true)
    setAllTime(false)

  }else if(type == 'signUp'){
    setDurationThree(6)
    let signUpData = {
      intervalId : 3,
      startsFrom : moment().subtract(1, 'month').startOf('month').format("YYYY-MM-DD")
    }

    let Label_X = []
    let Label_Y = []
    let signUpTotal = 0
    
    let res = await axios.post(BASE_URL + SIGN_UP , signUpData)

    res.data.data.forEach((element)=>{
      
      Label_X.push(moment(element.x.slice(0,10)).format('DD MMM'))
      setSignUpLabel(Label_X)

      Label_Y.push(element.y)
      setSignUpData(Label_Y)

      signUpTotal = signUpTotal + parseInt(element.y)
      setTotalSignUp(signUpTotal)

      setSignUpDateFrom(moment().subtract(1, 'month').startOf('month').format('MMMM DD, YYYY'))
      setSignUpDateTo(moment().subtract(1, 'month').endOf('month').format('MMMM DD, YYYY'))

    })

    setSignUpDaily(false)
    setSignUpYesterday(false)
    setSignUpWeekly(false)
    setSignUpLastWeek(false)
    setSignUpMonthly(false)
    setSignUpLastMonth(true)
    setSignUpAllTime(false)

  }
    
  }

  const [allTimeMoney, setAllTimeMoney] = useState(0)

  const changeAlltime = async(type) => {


    if(type == 'totalMoney'){
    setDurationOne(7)
    let moneyCollectedData = {
      intervalId : 5,
      startsFrom : startFrom
    }

    let Label_X = []
    let Label_Y = []
    let totalMoney = 0;
    
    let res = await axios.post(BASE_URL + TOTAL_MONEY_COLLECTED , moneyCollectedData)

    res.data.data.forEach((element)=>{
      Label_X.push(element.x.slice(0,10))
      setLabels(Label_X)

      Label_Y.push(element.y)
      setTotalMoneyData(Label_Y)

      totalMoney = totalMoney + parseInt(element.y)
      setDailyMoney(totalMoney)

      setMoneyDateFrom(moment(Label_X[0]).format("MMMM DD, YYYY"))
      setMoneyDateTo(moment().format("MMMM DD, YYYY"))
      
    })

    setMoneyDaily(false)
    setMoneyYestrday(false)
    setMoneyWeekly(false)
    setMoneyLastWeek(false)
    setMoneyMonthly(false)
    setMoneyLastMonth(false)
    setMoneyAllTime(true)

  }else if(type == 'hostingFee'){
    setDurationTwo(7)
    let hostingFeeData = {
      intervalId : 5,
      startsFrom : startFrom
    }

    let Label_X = []
    let Label_Y = []
    let hostingTotal = 0;
    
    let res = await axios.post(BASE_URL + TOTAL_HOSTING_FEE_COLLECTED , hostingFeeData)

    res.data.data.forEach((element)=>{
      
      Label_X.push(element.x.slice(0,10))
      setHostLabel(Label_X)

      Label_Y.push(element.y)
      setHostData(Label_Y)

      hostingTotal = hostingTotal + parseInt(element.y)
      setTotalHostingFee(hostingTotal)

      setHostingDateFrom(moment(Label_X[0]).format("MMMM DD, YYYY"))
      setHostingDateTo(moment().format("MMMM DD, YYYY"))
      
    })

    setDailly(false)
    setyesterday(false)
    setWeekly(false)
    setWeekLast(false)
    setMonthly(false)
    setMonthLast(false)
    setAllTime(true)

  }else if(type == 'signUp'){
    setDurationThree(7)
    let signUpData = {
      intervalId : 5,
      startsFrom : startFrom
    }

    let Label_X = []
    let Label_Y = []
    let signUpTotal = 0
    
    let res = await axios.post(BASE_URL + SIGN_UP , signUpData)

    res.data.data.forEach((element)=>{
      
      Label_X.push(element.x.slice(0,10))
      setSignUpLabel(Label_X)

      Label_Y.push(element.y)
      setSignUpData(Label_Y)

      signUpTotal = signUpTotal + parseInt(element.y)
      setTotalSignUp(signUpTotal)

      setSignUpDateFrom(moment(Label_X[0]).format("MMMM DD, YYYY"))
      setSignUpDateTo(moment().format("MMMM DD, YYYY"))

    })

    setSignUpDaily(false)
    setSignUpYesterday(false)
    setSignUpWeekly(false)
    setSignUpLastWeek(false)
    setSignUpMonthly(false)
    setSignUpLastMonth(false)
    setSignUpAllTime(true)

  }
    
  }

  const [show, setShow] = useState(false)
  const [showHosting, setShowHosting] = useState(false)
  const [showtotalMoney, setTotalMoney] = useState(false)
  const [showSignUp, setShowSignUp] = useState(false)
  
  const showHostingGraph = () => {
    // setOption(options = {maintainAspectRatio: false,})
    setShowHosting(true)
    setShowSignUp(false)
    setTotalMoney(false)
    setShow(true)
  }

  const showtotalMoneyGraph = () => {
    // setOption(options = {maintainAspectRatio: false,})
    setShowHosting(false)
    setShowSignUp(false)
    setTotalMoney(true)
    setShow(true)
  }

  const showSignUpGraph = () => {
    // setOption(options = {maintainAspectRatio: false,})
    setShowHosting(false)
    setShowSignUp(true)
    setTotalMoney(false)
    setShow(true)
  }

  const hide = () => {
    setShow(false)
  }

  
  /* On Page Load Data For Graph */

  const [intervalId, setIntervalId] = useState(1)
  const [startFrom, setStartFrom] = useState(new Date().toISOString().slice(0, 10))
  const [totalMoneyCollected , setTotalMoneyCollected] = useState()



  const initialTotalMoney = async() => {
    let moneyCollectedData = {
      intervalId : 5,
      startsFrom : startFrom
    }

    let Label_X = []
    let Label_Y = []
    let totalMoney = 0;
    
    let res = await axios.post(BASE_URL + TOTAL_MONEY_COLLECTED , moneyCollectedData)

    res.data.data.forEach((element)=>{
      Label_X.push(element.x.slice(0,10))
      setLabels(Label_X)

      Label_Y.push(element.y)
      setTotalMoneyData(Label_Y)

      totalMoney = totalMoney + parseInt(element.y)
      setDailyMoney(totalMoney)

      setMoneyDateFrom(moment(Label_X[0]).format("MMMM DD, YYYY"))
      setMoneyDateTo(moment().format("MMMM DD, YYYY"))
      
    })
  }

  const initialHostingFee = async() => {
    let hostingFeeData = {
      intervalId : 5,
      startsFrom : startFrom
    }

    let Label_X = []
    let Label_Y = []
    let hostingTotal = 0;
    
    let res = await axios.post(BASE_URL + TOTAL_HOSTING_FEE_COLLECTED , hostingFeeData)

    res.data.data.forEach((element)=>{
      
      Label_X.push(element.x.slice(0,10))
      setHostLabel(Label_X)

      Label_Y.push(element.y)
      setHostData(Label_Y)

      hostingTotal = hostingTotal + parseInt(element.y)
      setTotalHostingFee(hostingTotal)
      
      setHostingDateFrom(moment(Label_X[0]).format("MMMM DD, YYYY"))
      setHostingDateTo(moment().format("MMMM DD, YYYY"))
    })
  }

  const initialSignUp = async() => {
    let signUpData = {
      intervalId : 5,
      startsFrom : startFrom
    }

    let Label_X = []
    let Label_Y = []
    let signUpTotal = 0
    
    let res = await axios.post(BASE_URL + SIGN_UP , signUpData)

    res.data.data.forEach((element)=>{
      
      Label_X.push(element.x.slice(0,10))
      setSignUpLabel(Label_X)

      Label_Y.push(element.y)
      setSignUpData(Label_Y)

      signUpTotal = signUpTotal + parseInt(element.y)
      setTotalSignUp(signUpTotal)
      
      setSignUpDateFrom(moment(Label_X[0]).format("MMMM DD, YYYY"))
      setSignUpDateTo(moment().format("MMMM DD, YYYY"))

    })
  }

  const [duration, setDuration] = useState(7)
  const [durationOne, setDurationOne] = useState(7)
  const [durationTwo, setDurationTwo] = useState(7)
  const [durationThree, setDurationThree] = useState(7)
  

  const handleChangeOne = (e) => {
      setDurationOne(e.target.value)
  }

  const handleChangeTwo = (e) => {
    setDurationTwo(e.target.value)
}

const handleChangeThree = (e) => {
  setDurationThree(e.target.value)
}

  return (
    <>
      
      <Row className="mt-2 pt-2">
          <Col lg={12}>
            <Breadcrumb listProps={{className: "breadcrumb-transparent text-secondary"}}>
              <Breadcrumb.Item href='#overview'>Gamestarz</Breadcrumb.Item>
              <Breadcrumb.Item href='#overview'>Overview</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
      </Row>

      {show === true && showHosting == true ?
      <Row className="my-5 justify-content-md-center py-3 card h-100 mx-1">
          <Col xl={12} lg={12} md={12} sm={12} xs={12}>
            <Row className='text-right px-2'>
              <Col>
                <FontAwesomeIcon className="me-3" style={{cursor: "pointer", fontSize: "30px"}} onClick={hide} icon={faTimes} />
              </Col>
            </Row>
            <Row className='mt-5 mb-2 px-4 d-flex justify-content-between'>
              <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                  <h5><b>Total Hosting Fee Collected</b></h5>
              </Col>
              <Col xl={6} lg={6} md={12} sm={12} xs={12} className='text-right'>
                <ButtonGroup>
                    <Button size='sm' variant="white" className={daily === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeDaily('hostingFee')}} style={{border:'1px solid #eee', borderTopLeftRadius: "25px", borderBottomLeftRadius : '25px'}}>Today</Button>
                    <Button size='sm' variant="white" className={yesterday === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeYesterday('hostingFee')}} style={{border:'1px solid #eee'}}>Yesterday</Button>
                    <Button size='sm' variant="white" className={Weekly === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeWeekly('hostingFee')}} style={{border:'1px solid #eee'}}>This Week</Button>
                    <Button size='sm' variant="white" className={weekLast === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeLastWeek('hostingFee')}} style={{border:'1px solid #eee'}}>Last Week</Button>
                    <Button size='sm' variant="white" className={monthly === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeMonthly('hostingFee')}} style={{border:'1px solid #eee'}}>This Month</Button>
                    <Button size='sm' variant="white" className={monthLast === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeLastMonth('hostingFee')}} style={{border:'1px solid #eee'}}>Last Month</Button>
                    <Button size='sm' variant="white" className={alltime === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeAlltime('hostingFee')}} style={{border:'1px solid #eee', borderTopRightRadius: "25px", borderBottomRightRadius : '25px'}}>All Time</Button>
                </ButtonGroup>
              </Col>
            </Row>
            <Row>
              <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                <Line data={hostingFeeData} options={optionsNew} height={500} />
              </Col>
            </Row>
          </Col>
      </Row> 
      : showtotalMoney == true && show == true ?
      <Row className="my-5 justify-content-md-center py-3 card h-100 mx-1">
        <Col xl={12} lg={12} md={12} sm={12} xs={12}>
          <Row className='text-right px-2'>
            <Col>
              <FontAwesomeIcon className="me-3" style={{cursor: "pointer", fontSize: "30px"}} onClick={hide} icon={faTimes} />
            </Col>
          </Row>
          <Row className='mt-5 mb-2 px-4 d-flex justify-content-between'>
              <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                  <h5><b>Total Prize Money Distributed</b></h5>
              </Col>
              <Col xl={6} lg={6} md={6} sm={12} xs={12} className='text-right'>
              <ButtonGroup>
                  <Button size='sm' variant="white" className={moneyDaily === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeDaily('totalMoney')}} style={{border:'1px solid #eee', borderTopLeftRadius: "25px", borderBottomLeftRadius : '25px'}}>Today</Button>
                  <Button size='sm' variant="white" className={moneyYestrday === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeYesterday('totalMoney')}} style={{border:'1px solid #eee'}}>Yesterday</Button>
                  <Button size='sm' variant="white" className={moneyweekly === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeWeekly('totalMoney')}} style={{border:'1px solid #eee'}}>This Week</Button>
                  <Button size='sm' variant="white" className={moneyLastWeek === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeLastWeek('totalMoney')}} style={{border:'1px solid #eee'}}>Last Week</Button>
                  <Button size='sm' variant="white" className={moneyMonthly === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeMonthly('totalMoney')}} style={{border:'1px solid #eee'}}>This Month</Button>
                  <Button size='sm' variant="white" className={moneyLastMonth === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeLastMonth('totalMoney')}} style={{border:'1px solid #eee'}}>Last Month</Button>
                  <Button size='sm' variant="white" className={moneyAllTime === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeAlltime('totalMoney')}} style={{border:'1px solid #eee', borderTopRightRadius: "25px", borderBottomRightRadius : '25px'}}>All Time</Button>
              </ButtonGroup>
            </Col>
          </Row>
            <Row>
              <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                <Line data={moneyCollectedData} options={optionsNew} height={500} />
              </Col>
            </Row>
          </Col>
      </Row> 
      : showSignUp == true && show == true ?
      <Row className="my-5 justify-content-md-center py-3 card h-100 mx-1">
        <Col xl={12} lg={12} md={12} sm={12} xs={12}>
          <Row className='text-right px-2'>
            <Col>
              <FontAwesomeIcon className="me-3" style={{cursor: "pointer", fontSize: "30px"}} onClick={hide} icon={faTimes} />
            </Col>
          </Row>
          <Row className='mt-5 mb-2 px-4 d-flex justify-content-between'>
              <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                  <h5><b>Total Sign Up</b></h5>
              </Col>
            <Col xl={6} lg={6} md={6} sm={12} xs={12} className='text-right'>
              <ButtonGroup>
                    <Button size='sm' variant="white" className={signUpDaily === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeDaily('signUp')}} style={{border:'1px solid #eee', borderTopLeftRadius: "25px", borderBottomLeftRadius : '25px'}}>Today</Button>
                    <Button size='sm' variant="white" className={signUpYesterday === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeYesterday('signUp')}} style={{border:'1px solid #eee'}}>Yesterday</Button>
                    <Button size='sm' variant="white" className={signUpWeekly === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeWeekly('signUp')}} style={{border:'1px solid #eee'}}>This Week</Button>
                    <Button size='sm' variant="white" className={signUpLastWeek === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeLastWeek('signUp')}} style={{border:'1px solid #eee'}}>Last Week</Button>
                    <Button size='sm' variant="white" className={signUpMonthly === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeMonthly('signUp')}} style={{border:'1px solid #eee'}}>This Month</Button>
                    <Button size='sm' variant="white" className={signUpLastMonth === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeLastMonth('signUp')}} style={{border:'1px solid #eee'}}>Last Month</Button>
                    <Button size='sm' variant="white" className={signUpAllTime === true ? "btn-state text-white" : 'text-dark'} onClick={()=>{changeAlltime('signUp')}} style={{border:'1px solid #eee', borderTopRightRadius: "25px", borderBottomRightRadius : '25px'}}>All Time</Button>
                </ButtonGroup>
            </Col>
          </Row>
          <Row>
            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
              <Line data={userData} options={optionsNew} height={500} />
            </Col>
          </Row>
        </Col>
      </Row> 
      : ""}

      <Row className={show === false ? "justify-content-md-center mt-3" : "justify-content-md-center"}>
        <Col xl={4} lg={4} md={6} sm={12} xs={12} className="mb-4">
          <Row className="card mx-1 py-2">
              <Col>
                <Row className="p-3">
                  <Col>
                      <h3 style={{fontWeight: '700', fontFamily: 'Inter, sans-serif', marginBottom: '0px'}}>&#8377; {totalHostingFee}</h3>
                      <h6 style={{color: '#8F8F8F'}}>Hosting Fee Collected Total</h6>
                      <span style={{color: '#333336', fontWeight: 'bold'}}>{hostingDateFrom} to {hostingDateTo}</span>
                  </Col>
                </Row>
                <Row className="align-items-center">
                  <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                    <Line data={hostingFeeData} options={options} onClick={showHostingGraph} style={{cursor: "pointer"}}/>
                  </Col>
                </Row>
              </Col>
          </Row>
        </Col>

        <Col xl={4} lg={4} md={6} sm={12} xs={12} className="mb-4">
          <Row className="card mx-1 py-2">
              <Col>
                  <Row className="p-3">
                    <Col>
                        <h3 style={{fontWeight: '700', fontFamily: 'Inter, sans-serif', marginBottom: '0px'}}>&#8377; {dailyMoney}</h3>
                        <h6 style={{color: '#8F8F8F'}}>Total Prize Money Distributed</h6>
                        <span style={{color: '#333336', fontWeight: 'bold'}}>{moneyDateFrom} to {moneyDateTo}</span>
                    </Col>
                  </Row>
                  <Row className="align-items-center">
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <Line data = {moneyCollectedData} onClick={showtotalMoneyGraph} options={options} style={{cursor: "pointer"}}/>
                    </Col>
                  </Row>
              </Col>
          </Row>
        </Col>

        <Col xl={4} lg={4} md={6} sm={12} xs={12} className="mb-4">
          <Row className="card mx-1 py-2">
              <Col>
                  <Row className='p-3'>
                      <Col>
                          <h3 style={{fontWeight: '700', fontFamily: 'Inter, sans-serif', marginBottom: '0px'}}>{totalSignUp}</h3>
                          <h6 style={{color: '#8F8F8F'}}>Total Signup</h6>
                          <span style={{color: '#333336', fontWeight: 'bold'}}>{signUpDateFrom} to {signUpDateTo}</span>
                          <br />
                      </Col>
                  </Row>
                  <Row className="align-items-center">
                    <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                      <Line data = {userData} onClick={showSignUpGraph} options={options} style={{cursor: "pointer"}}/>
                    </Col>
                  </Row>
              </Col>
          </Row>
        </Col>

      </Row>

      <Row>
        <Col xl={12} lg={12} md={12} sm={12} xs={12} className="mb-4">
          <div className="card statistic p-4">
            <Row className="mb-2">
              <Col lg={12} md={12} sm={12}>
                <h4><b>Statistics</b></h4>
              </Col>
            </Row>

            <Row className="my-2">
              <Col xl={6} lg={6} md={6} sm={12} xs={12}> 
                  <Row className="align-items-center mb-4 mb-xl-0 mb-lg-0">
                    <Col xl={2} lg={2} md={2} sm={2} xs={2}>
                      <svg width="40" height="40" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect y="0.959961" width="56" height="56" rx="8" fill="#FFAB00"/>
                        <path d="M8.18477 44.7704C13.1069 47.9733 17.8109 39.1793 22.0163 35.5836C22.2134 35.4151 22.5849 35.2866 22.8396 35.2866H33.1605C33.4147 35.2866 33.7858 35.4151 33.9833 35.5836C38.1887 39.1793 42.8932 47.9728 47.8149 44.7704C51.9063 42.1088 49.1451 22.7058 48.3521 20.2563C46.952 15.9328 43.6403 13.3147 39.9819 12.5455C39.7326 12.4932 39.3224 12.46 39.0687 12.46H16.9314C16.6767 12.46 16.267 12.4932 16.0177 12.5455C12.3599 13.3147 9.04814 15.9328 7.64748 20.2563C6.855 22.7064 4.09377 42.1088 8.18477 44.7704ZM38.8844 29.5895C37.8675 29.5895 37.0423 28.725 37.0423 27.6608C37.0423 26.5955 37.8675 25.7321 38.8844 25.7321C39.9013 25.7321 40.7255 26.5955 40.7255 27.6608C40.725 28.7255 39.9013 29.5895 38.8844 29.5895ZM42.5095 21.934C43.5259 21.934 44.3511 22.798 44.3511 23.8633C44.3511 24.928 43.5259 25.792 42.5095 25.792C41.4926 25.792 40.6678 24.928 40.6678 23.8633C40.6678 22.798 41.4926 21.934 42.5095 21.934ZM38.8844 18.137C39.9013 18.137 40.7255 19.0005 40.7255 20.0658C40.7255 21.131 39.9013 21.995 38.8844 21.995C37.8675 21.995 37.0423 21.1305 37.0423 20.0658C37.0423 19 37.8675 18.137 38.8844 18.137ZM35.2593 21.934C36.2757 21.934 37.1004 22.798 37.1004 23.8633C37.1004 24.928 36.2757 25.792 35.2593 25.792C34.2419 25.792 33.4177 24.928 33.4177 23.8633C33.4177 22.798 34.2419 21.934 35.2593 21.934ZM13.2775 23.051C13.2775 22.9512 13.3547 22.8697 13.4501 22.8697H16.2123C16.3076 22.8697 16.3853 22.7893 16.3853 22.6889V19.7953C16.3853 19.696 16.4621 19.6146 16.5579 19.6146H18.7452C18.84 19.6146 18.9178 19.6955 18.9178 19.7953V22.6889C18.9178 22.7888 18.995 22.8697 19.0908 22.8697H21.8526C21.9479 22.8697 22.0256 22.9506 22.0256 23.051V25.3418C22.0256 25.4417 21.9484 25.5226 21.8526 25.5226H19.0908C18.9955 25.5226 18.9178 25.6035 18.9178 25.7039V28.597C18.9178 28.6969 18.8405 28.7783 18.7452 28.7783H16.5579C16.4626 28.7783 16.3853 28.6974 16.3853 28.597V25.7039C16.3853 25.604 16.3081 25.5226 16.2123 25.5226H13.4501C13.3552 25.5226 13.2775 25.4417 13.2775 25.3418V23.051Z" fill="#FAFAFA"/>
                      </svg>
                    </Col>
                    <Col xl={5} lg={5} md={5} sm={6} xs={6}>
                        <span style={{color: '#111928'}}><b>Total Games</b></span>
                    </Col>
                    <Col xl={4} lg={4} md={4} sm={4} xs={4}>
                      <span style={{color: '#111928'}}>{gameStats}</span>
                    </Col>
                  </Row>
              </Col>
              <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                <Row className="align-items-center mb-xl-0 mb-lg-0 mb-md-3 mb-sm-3 mb-xs-3">
                  <Col xl={2} lg={2} md={2} sm={2} xs={2}>
                  <svg width="40" height="40" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect y="0.959961" width="56" height="56" rx="8" fill="#5BD6FF"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M50.4 28.9599C50.4 34.9008 48.04 40.5983 43.8392 44.7991C39.6384 48.9999 33.9408 51.3599 28 51.3599C22.0592 51.3599 16.3616 48.9999 12.1608 44.7991C7.95999 40.5983 5.6 34.9008 5.6 28.9599C5.6 23.0191 7.95999 17.3216 12.1608 13.1207C16.3616 8.91993 22.0592 6.55994 28 6.55994C33.9408 6.55994 39.6384 8.91993 43.8392 13.1207C48.04 17.3216 50.4 23.0191 50.4 28.9599ZM44.8 28.9599C44.8 31.7403 44.1252 34.3611 42.9296 36.6711L38.6624 32.4011C39.3013 30.4235 39.377 28.307 38.8808 26.2887L43.2544 21.9151C44.2456 24.0571 44.8 26.4399 44.8 28.9599ZM30.338 39.9163L34.762 44.3403C32.6312 45.2785 30.3282 45.762 28 45.7599C25.5673 45.763 23.1632 45.2355 20.9552 44.2143L25.3288 39.8407C26.9715 40.2433 28.6839 40.2691 30.338 39.9163ZM17.2424 32.0875C16.6914 30.1903 16.6518 28.181 17.1276 26.2635L16.9036 26.4875L12.6196 22.1951C11.6811 24.3268 11.1976 26.6308 11.2 28.9599C11.2 31.6311 11.8244 34.1567 12.9332 36.3995L17.2452 32.0875H17.2424ZM20.2888 14.0275C22.6722 12.7956 25.317 12.155 28 12.1599C30.6712 12.1599 33.1968 12.7843 35.4396 13.8931L31.1276 18.2051C28.9779 17.579 26.69 17.6112 24.5588 18.2975L20.2888 14.0303V14.0275ZM33.6 28.9599C33.6 30.4451 33.01 31.8695 31.9598 32.9197C30.9096 33.9699 29.4852 34.5599 28 34.5599C26.5148 34.5599 25.0904 33.9699 24.0402 32.9197C22.99 31.8695 22.4 30.4451 22.4 28.9599C22.4 27.4747 22.99 26.0503 24.0402 25.0001C25.0904 23.9499 26.5148 23.3599 28 23.3599C29.4852 23.3599 30.9096 23.9499 31.9598 25.0001C33.01 26.0503 33.6 27.4747 33.6 28.9599Z" fill="#FAFAFA"/>
                  </svg>

                  </Col>
                  <Col xl={5} lg={5} md={5} sm={6} xs={6}>
                    <span style={{color: '#111928'}}><b>Total Competitions</b></span>
                  </Col>
                  <Col xl={2} lg={2} md={2} sm={2} xs={2}>
                      <span style={{color: '#111928'}}>{competitionStats}</span>
                  </Col>
                  <Col>
                    <Button as={Link} to={{pathname:Routes.Competition.path}} style={{backgroundColor : '#7A4BFF', border: 'none', borderRadius: '40px', fontSize: '14px'}}>
                      <span>View All</span>
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row className="my-3">
              <Col xl={6} lg={6} md={6} sm={12} xs={12}> 
                  <Row className="align-items-center mb-4 mb-xl-0 mb-lg-0">
                    <Col xl={2} lg={2} md={2} sm={2} xs={2}>
                    <svg width="40" height="40" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect y="0.959961" width="56" height="56" rx="8" fill="#5BD6FF"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M50.4 28.9599C50.4 34.9008 48.04 40.5983 43.8392 44.7991C39.6384 48.9999 33.9408 51.3599 28 51.3599C22.0592 51.3599 16.3616 48.9999 12.1608 44.7991C7.95999 40.5983 5.6 34.9008 5.6 28.9599C5.6 23.0191 7.95999 17.3216 12.1608 13.1207C16.3616 8.91993 22.0592 6.55994 28 6.55994C33.9408 6.55994 39.6384 8.91993 43.8392 13.1207C48.04 17.3216 50.4 23.0191 50.4 28.9599ZM44.8 28.9599C44.8 31.7403 44.1252 34.3611 42.9296 36.6711L38.6624 32.4011C39.3013 30.4235 39.377 28.307 38.8808 26.2887L43.2544 21.9151C44.2456 24.0571 44.8 26.4399 44.8 28.9599ZM30.338 39.9163L34.762 44.3403C32.6312 45.2785 30.3282 45.762 28 45.7599C25.5673 45.763 23.1632 45.2355 20.9552 44.2143L25.3288 39.8407C26.9715 40.2433 28.6839 40.2691 30.338 39.9163ZM17.2424 32.0875C16.6914 30.1903 16.6518 28.181 17.1276 26.2635L16.9036 26.4875L12.6196 22.1951C11.6811 24.3268 11.1976 26.6308 11.2 28.9599C11.2 31.6311 11.8244 34.1567 12.9332 36.3995L17.2452 32.0875H17.2424ZM20.2888 14.0275C22.6722 12.7956 25.317 12.155 28 12.1599C30.6712 12.1599 33.1968 12.7843 35.4396 13.8931L31.1276 18.2051C28.9779 17.579 26.69 17.6112 24.5588 18.2975L20.2888 14.0303V14.0275ZM33.6 28.9599C33.6 30.4451 33.01 31.8695 31.9598 32.9197C30.9096 33.9699 29.4852 34.5599 28 34.5599C26.5148 34.5599 25.0904 33.9699 24.0402 32.9197C22.99 31.8695 22.4 30.4451 22.4 28.9599C22.4 27.4747 22.99 26.0503 24.0402 25.0001C25.0904 23.9499 26.5148 23.3599 28 23.3599C29.4852 23.3599 30.9096 23.9499 31.9598 25.0001C33.01 26.0503 33.6 27.4747 33.6 28.9599Z" fill="#FAFAFA"/>
                    </svg>
                    </Col>
                    <Col xl={5} lg={5} md={5} sm={6} xs={6}>
                        <span style={{color: '#111928'}}><b>Total Challanges</b></span>
                    </Col>
                    <Col xl={4} lg={4} md={4} sm={4} xs={4}>
                      <span style={{color: '#111928'}}>{totalChallenges}</span>
                    </Col>
                  </Row>
              </Col>
              <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                <Row className="align-items-center mb-xl-0 mb-lg-0 mb-md-3 mb-sm-3 mb-xs-3">
                  <Col xl={2} lg={2} md={2} sm={2} xs={2}>
                  <svg width="40" height="40" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect y="0.959961" width="56" height="56" rx="8" fill="#5BD6FF"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M50.4 28.9599C50.4 34.9008 48.04 40.5983 43.8392 44.7991C39.6384 48.9999 33.9408 51.3599 28 51.3599C22.0592 51.3599 16.3616 48.9999 12.1608 44.7991C7.95999 40.5983 5.6 34.9008 5.6 28.9599C5.6 23.0191 7.95999 17.3216 12.1608 13.1207C16.3616 8.91993 22.0592 6.55994 28 6.55994C33.9408 6.55994 39.6384 8.91993 43.8392 13.1207C48.04 17.3216 50.4 23.0191 50.4 28.9599ZM44.8 28.9599C44.8 31.7403 44.1252 34.3611 42.9296 36.6711L38.6624 32.4011C39.3013 30.4235 39.377 28.307 38.8808 26.2887L43.2544 21.9151C44.2456 24.0571 44.8 26.4399 44.8 28.9599ZM30.338 39.9163L34.762 44.3403C32.6312 45.2785 30.3282 45.762 28 45.7599C25.5673 45.763 23.1632 45.2355 20.9552 44.2143L25.3288 39.8407C26.9715 40.2433 28.6839 40.2691 30.338 39.9163ZM17.2424 32.0875C16.6914 30.1903 16.6518 28.181 17.1276 26.2635L16.9036 26.4875L12.6196 22.1951C11.6811 24.3268 11.1976 26.6308 11.2 28.9599C11.2 31.6311 11.8244 34.1567 12.9332 36.3995L17.2452 32.0875H17.2424ZM20.2888 14.0275C22.6722 12.7956 25.317 12.155 28 12.1599C30.6712 12.1599 33.1968 12.7843 35.4396 13.8931L31.1276 18.2051C28.9779 17.579 26.69 17.6112 24.5588 18.2975L20.2888 14.0303V14.0275ZM33.6 28.9599C33.6 30.4451 33.01 31.8695 31.9598 32.9197C30.9096 33.9699 29.4852 34.5599 28 34.5599C26.5148 34.5599 25.0904 33.9699 24.0402 32.9197C22.99 31.8695 22.4 30.4451 22.4 28.9599C22.4 27.4747 22.99 26.0503 24.0402 25.0001C25.0904 23.9499 26.5148 23.3599 28 23.3599C29.4852 23.3599 30.9096 23.9499 31.9598 25.0001C33.01 26.0503 33.6 27.4747 33.6 28.9599Z" fill="#FAFAFA"/>
                  </svg>
                  </Col>
                  <Col xl={5} lg={5} md={5} sm={6} xs={6}>
                    <span style={{color: '#111928'}}><b>Total Paid Challanges</b></span>
                  </Col>
                  <Col xl={4} lg={4} md={4} sm={4} xs={4}>
                      <span style={{color: '#111928'}}>{totalPaidChallenges}</span>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row>
                <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                    <Row className="align-items-center mb-xl-0 mb-lg-0 mb-md-3 mb-sm-3 mb-xs-3">
                      <Col xl={2} lg={2} md={2} sm={2} xs={2}>
                        <svg width="40" height="40" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect y="0.959961" width="56" height="56" rx="8" fill="#5BD6FF"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M50.4 28.9599C50.4 34.9008 48.04 40.5983 43.8392 44.7991C39.6384 48.9999 33.9408 51.3599 28 51.3599C22.0592 51.3599 16.3616 48.9999 12.1608 44.7991C7.95999 40.5983 5.6 34.9008 5.6 28.9599C5.6 23.0191 7.95999 17.3216 12.1608 13.1207C16.3616 8.91993 22.0592 6.55994 28 6.55994C33.9408 6.55994 39.6384 8.91993 43.8392 13.1207C48.04 17.3216 50.4 23.0191 50.4 28.9599ZM44.8 28.9599C44.8 31.7403 44.1252 34.3611 42.9296 36.6711L38.6624 32.4011C39.3013 30.4235 39.377 28.307 38.8808 26.2887L43.2544 21.9151C44.2456 24.0571 44.8 26.4399 44.8 28.9599ZM30.338 39.9163L34.762 44.3403C32.6312 45.2785 30.3282 45.762 28 45.7599C25.5673 45.763 23.1632 45.2355 20.9552 44.2143L25.3288 39.8407C26.9715 40.2433 28.6839 40.2691 30.338 39.9163ZM17.2424 32.0875C16.6914 30.1903 16.6518 28.181 17.1276 26.2635L16.9036 26.4875L12.6196 22.1951C11.6811 24.3268 11.1976 26.6308 11.2 28.9599C11.2 31.6311 11.8244 34.1567 12.9332 36.3995L17.2452 32.0875H17.2424ZM20.2888 14.0275C22.6722 12.7956 25.317 12.155 28 12.1599C30.6712 12.1599 33.1968 12.7843 35.4396 13.8931L31.1276 18.2051C28.9779 17.579 26.69 17.6112 24.5588 18.2975L20.2888 14.0303V14.0275ZM33.6 28.9599C33.6 30.4451 33.01 31.8695 31.9598 32.9197C30.9096 33.9699 29.4852 34.5599 28 34.5599C26.5148 34.5599 25.0904 33.9699 24.0402 32.9197C22.99 31.8695 22.4 30.4451 22.4 28.9599C22.4 27.4747 22.99 26.0503 24.0402 25.0001C25.0904 23.9499 26.5148 23.3599 28 23.3599C29.4852 23.3599 30.9096 23.9499 31.9598 25.0001C33.01 26.0503 33.6 27.4747 33.6 28.9599Z" fill="#FAFAFA"/>
                        </svg>
                      </Col>
                      <Col xl={5} lg={5} md={5} sm={6} xs={6}>
                        <span style={{color: '#111928'}}><b>Total Live Competition</b></span>
                      </Col>
                      <Col xl={4} lg={4} md={4} sm={4} xs={4}>
                          <span style={{color: '#111928'}}>{totalLiveCompetition}</span>
                      </Col>
                    </Row>
                </Col>

            </Row>

          </div>
          
        </Col>
      </Row>

      <Row className="justify-content-md-center">
        <Col xl={12} lg={12} md={12} sm={12} xs={12} className="mb-4">
          <div className="Playstaz_Ranks card p-4">
              <Row className="mb-3 align-items-center">
                <Col>
                    <h4><b>Gamestarz Leaderboard</b></h4>
                </Col>
                <Col className="text-right">
                    <Button as={Link} to={{pathname:Routes.LeaderboardDetail.path, id:'0280c259-f9ec-4f63-99cc-2e78a9c78f5c', leaderboardName : "playstarz"}} style={{backgroundColor : '#7A4BFF', border: 'none', borderRadius: '40px', fontSize: '14px'}}>
                      <span>View All</span>
                    </Button>
                </Col>
              </Row>

              <div className="playstarz table-responsive">
                <table class="table table-striped table-borderless">
                  <thead style={{backgroundColor:'#FFAB00', color: '#fff'}}>
                    <tr> 
                      <th style={{borderTopLeftRadius: '15px'}} scope="col">Rank</th>
                      <th scope="col">USER NAME</th>
                      <th scope="col">PLAYER ID</th>
                      <th style={{borderTopRightRadius: '15px'}} scope="col">PLAYER'S PLAYSTARZ POINTS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Leaderboard && Leaderboard.map((e,i)=>{
                        return(
                          <tr>
                            <th scope="row" className="align-middle">{e.ranks}</th>
                            <td className="align-middle"><span style={{marginRight: '15px'}}><FontAwesomeIcon  icon={faUserAlt} style={{fontSize: '15px'}}/></span><span><b>{e.users.username}</b></span></td>
                            <td className="align-middle">{e.users.id}</td>
                            <td className="align-middle"><b>{e.playstarz_point}</b></td>
                          </tr>
                        )
                    })}
                  </tbody>
                </table>
              </div>
          </div>
        </Col>
      </Row>

      {/* <Row className="pt-4 justify-content-center">
          <Col xl={12} lg={12} md={12} sm={12} xs={12}>
              <Row>
                  <Col xl={6} lg={6} md={12} sm={12} xs={12} className='mb-md-3 mb-sm -3'>
                      <div className="card p-3">
                      <Row className='mb-2'>
                          <Col lg={12} md={12} sm={12}>
                            <h4><b>Live Competitions</b></h4>
                          </Col>
                      </Row>

                       {competition && competition.map((e)=>{
                          if(e.competitionStatus == 'in progress' && e.archive == false){
                            return(
                              <>
                                <Row className="align-items-center my-1">
                                  <Col xl={2} lg={2} md={2} sm={12} xs={12}>
                                    <div className="cal">
                                      <div className="cal-month">{e.startDate != null ? moment(e.startDate).format('MMMM').toLocaleUpperCase().slice(0,3) : "-"}</div>
                                      <div className="cal-day"><b>{e.startDate != null ? moment(e.startDate).format("YYYY-MM-DD").slice(8,10) : "-"}</b></div>
                                    </div>
                                  </Col>
                                  <Col xl={10} lg={10} md={10} sm={12} xs={12}>
                                      <div className='mt-3'>
                                          <h5 style={{color: '#111928', fontWeight: '900', fontSize: '20px'}}>{e.competitionName}</h5>
                                          <h6 style={{color: '#48454E', fontSize: '16px'}}>{e.game.gameName} - {e.match.matchName}</h6>
                                          <p style={{color: '#48454E', fontSize: '14px'}}>{e.startDate != null && e.endDate !=null ? e.startDate.slice(0,10) + "to" + e.endDate.slice(0,10) : ""}</p>
                                      </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                                    <hr />
                                  </Col>
                                </Row>
                              </>
                            )
                          }
                      })}
                      </div>
                  </Col>


                  <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                    <div className="card p-3">
                      <Row className='mb-2'>
                          <Col lg={12} md={12} sm={12}>
                            <h4><b>Upcoming Competitions</b></h4>
                          </Col>
                      </Row>
                      {competition && competition.map((e)=>{
                          if(e.competitionStatus == 'yet to start' && e.archive == false){
                            return(
                              <>
                                <Row className="align-items-center my-1">
                                  <Col xl={2} lg={2} md={2} sm={12} xs={12}>
                                    <div className="cal">
                                      <div className="cal-month">{e.startDate != null ? moment(e.startDate).format('MMMM').toLocaleUpperCase().slice(0,3) : "-"}</div>
                                      <div style={{}} className="cal-day"><b>{e.startDate != null ? moment(e.startDate).format("YYYY-MM-DD").slice(8,10) : "-"}</b></div>
                                    </div>
                                  </Col> 
                                  <Col xl={10} lg={10} md={10} sm={12} xs={12}>
                                      <div className='mt-3'>
                                          <h5 style={{color: '#111928', fontWeight: '900', fontSize: '20px'}}>{e.competitionName}</h5>
                                          <h6 style={{color: '#48454E', fontSize: '16px'}}>{e.game.gameName} - {e.match.matchName}</h6>
                                          <p style={{color: '#48454E', fontSize: '14px'}}>{e.startDate != null && e.endDate !=null ? e.startDate.slice(0,10) + "to" + e.endDate.slice(0,10) : ""}</p>
                                      </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                                    <hr />
                                  </Col>
                                </Row>
                              </>
                            )
                          }
                      })}
                    </div>
                  </Col>
              </Row>
          </Col>
      </Row> */}

      

    </>
  );
};
